import React from "react";
import BeneficiaryManager from "./BeneficiaryManager";
import BeneficiaryRequestFr, {
  beneficiariesRequestedFromOperations,
} from "./BeneficiaryRequestFr";

interface BeneficiariesRouteProps {
  domain?: string;
  userName: string;
  onBack: () => void;
}

/**
 * La sección `beneficiaries` del portal. FR (Carlos, 5-nov-2026): la designación la escribe ms-scor y
 * solo entra por Operaciones, así que se pinta la página que manda la solicitud a Operaciones. Los
 * demás mercados siguen con `BeneficiaryManager` sin cambios.
 */
const BeneficiariesRoute = ({ domain, userName, onBack }: BeneficiariesRouteProps) =>
  beneficiariesRequestedFromOperations(domain) ? (
    <BeneficiaryRequestFr onBack={onBack} />
  ) : (
    <BeneficiaryManager userName={userName} onBack={onBack} />
  );

export default BeneficiariesRoute;
